import styled from '@emotion/styled';
import { TableCell, TableRow } from '@mui/material';

export const StyledTableRow = styled(TableRow)``;
export const StyledTableCell = styled(TableCell)``;
